import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./axiosBaseQuery";

/**
 * Empty base API slice. Each entity injects its own endpoints via
 * `apiSlice.injectEndpoints` (see usersApi.ts for the reference pattern),
 * so this file only grows in `tagTypes` as new entities migrate.
 */
export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery(),
  // Global freshness semantics: cached data paints instantly while a
  // background refetch revalidates on every mount (matches the pre-migration
  // "always refetch on page enter" behavior without a loading flash).
  refetchOnMountOrArgChange: true,
  // Revalidate after the network comes back (laptop sleep / wifi drop).
  // refetchOnFocus stays off on purpose: tab switching would cause request
  // storms without adding freshness that reconnect/mount don't already cover.
  refetchOnReconnect: true,
  tagTypes: [
    "User",
    "Course",
    "Project",
    "Lesson",
    "GameQuiz",
    "GameQuizAttempt",
    "SandboxResource",
    "School",
    "KinderGraduation",
    "Program",
    "Resource",
    "Grade",
    "Subject",
    "AuditLog",
    "AdminAccess",
    "AppVersion",
    "Trash",
    "OdReviewRun",
    "OdReviewIssue",
    "Training",
    "DataQuestion",
  ],
  endpoints: () => ({}),
});
